import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createUser } from "../../../api/users";
import UserForm from "./UserForm";

const CreateUser = () => {
  const [userDetails, setUserDetails] = useState({ admin: false });
  const [formErrors, setFormErrors] = useState({});

  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate: createUserMutation, isLoading } = useMutation({
    mutationFn: (data) => {
      return createUser(data);
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: ["users"],
      });
      toast.success(response?.data?.message ?? "User added", {
        toastId: "user-added",
      });
      navigate("/admin/users");
    },
    onError: (error) => {
      // 422 = invalid input, shown against the matching form fields
      const errors =
        error?.response?.status === 422
          ? (error.response.data?.errors ?? {})
          : {};
      setFormErrors(errors);

      toast.error(
        errors.license
          ? "You don't have any more Sidekick licences available to assign."
          : "There was problem adding the user. Please try again.",
        { toastId: "user-creation-error" },
      );
    },
  });

  const handleSubmit = async () => {
    createUserMutation(userDetails);
  };

  const handleCancel = () => {
    navigate("/admin/users");
  };

  return (
    <>
      <UserForm
        formErrors={formErrors}
        userDetails={userDetails}
        setUserDetails={setUserDetails}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        isLoading={isLoading}
      />
    </>
  );
};

export default CreateUser;
